import React from 'react';
import { useLang } from '@/i18n/LanguageContext';
import PageContainer from '@/components/PageContainer';
import PageHeader from '@/components/PageHeader';

export default function Cabinet() {
  const { t } = useLang();
  const c = t.cabinet;

  return (
    <PageContainer>
      <PageHeader kicker={c.kicker} title={c.title} />

      <div className="mt-10 space-y-6 text-[17px] leading-[1.85] text-navy/85 animate-fade-up text-justify">
        <p>{c.p1}</p>
        <ul className="space-y-3 pl-1">
          {c.bullets.map((b, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="mt-2 h-1.5 w-1.5 rotate-45 bg-[var(--color-gold)] flex-shrink-0" />
              <span>{b}</span>
            </li>
          ))}
        </ul>
        <p>{c.p2}</p>

        <div className="mt-10 border-l-2 border-[var(--color-gold)] pl-6 py-2">
          <p className="text-[11px] tracking-[0.3em] uppercase text-[var(--color-gold)] mb-2 font-semibold text-left">
            {c.objectiveLabel}
          </p>
          <p className="font-display text-2xl md:text-3xl text-navy leading-snug text-justify">
            {c.objective}
          </p>
        </div>
      </div>

      {/* Highlights */}
      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {c.highlights.map((h, i) => (
          <div
            key={i}
            className="group bg-white border border-[var(--color-taupe)]/15 p-6 hover:border-[var(--color-gold)] hover:shadow-lg transition-all duration-300"
          >
            <div className="w-10 h-px bg-[var(--color-gold)] mb-4 group-hover:w-16 transition-all duration-300" />
            <h3 className="font-display text-xl text-navy mb-2">{h.title}</h3>
            <p className="text-sm text-navy/70 leading-relaxed">{h.text}</p>
          </div>
        ))}
      </div>
    </PageContainer>
  );
}
